import { FC } from "react";
import { Button } from "@chakra-ui/react";
import { AppIcon } from "./AppIcon";

type AppFilterButtonProps = {
    filterData: any;
};

export const AppFilterButton: FC<AppFilterButtonProps> = ({ filterData }) => {
    return (
        <Button
            variant={
                Object.keys(filterData)?.length > 0 ? "primary" : "outline"
            }
            className="btn-icon-md"
            size="md"
        >
            <AppIcon name="icl-filter" />
            {Object.keys(filterData)?.length > 0 && (
                <span
                    style={{
                        fontSize: "10px",
                        position: "absolute",
                        top: "-12px",
                        right: "-12px",
                        width: "24px",
                        height: "24px",
                        background: "var(--chakra-colors-white)",
                        color: "var(--chakra-colors-primary)",
                        borderRadius: "20px",
                        border: "1px solid var(--chakra-colors-primary)",
                    }}
                >
                    {Object.keys(filterData)?.length}
                </span>
            )}
        </Button>
    );
};
